module.exports = __webpack_public_path__ + "img/validate-rotate.bf699e82.gif";